<template>
  <div>
    <div class="text-h6 mt-2 mb-4">Changement de parcours pour {{ inscription.prenom }} {{ inscription.nom }}</div>
    <div class="ml-2 my-2">
      <div v-for="(choix_course, index_choix_course) in inscription.list_courses.list" :key="index_choix_course">
        <v-checkbox color="primary-dark" hide-details :label="get_label_choix_course(choix_course)"
          v-model="choix_course.selected" @change="updateSelectionCourse(index_choix_course)"></v-checkbox>

        <div v-if="choix_course.vagues.list.length > 0 && choix_course.selected">
          <div>
            <v-radio-group label="Choix de la vague de départ" v-model="choix_course.vague_selected"
              @change="updateSelectionVague(index_choix_course)">
              <v-radio class="radio_vagues" color="primary-dark" hide-details
                v-for="(vague, index_vague) in choix_course.vagues.list" :key="index_vague" :value="vague.id">
                <template v-slot:label>
                  <div>
                    {{ vague.nom }}
                    <span v-if="vague.places_restantes > 0 && vague.places_restantes < 1000">({{ vague.places_restantes
                      }} places restantes)</span>
                    <span v-if="vague.places_restantes <= 0"> (complet | {{ vague.nb_inscrits }}/{{ vague.nombre }}
                      inscrits)</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {
      inscription: {},
    };
  },
  methods: {
    get_label_choix_course(course) {
      let notice = "";
      if (parseInt(course.max_inscrits) <= parseInt(course.nb_inscrits) && parseInt(course.max_inscrits) != 0) {
        notice = " (complet)";
      }
      else if (course.ouvert == '0') {
        notice = " (fermé)";
      }
      else if (parseInt(course.max_inscrits) != 0) {
        notice = " (" + course.nb_inscrits + "/" + course.max_inscrits + " inscrits)";
      } else {
        notice = " (" + course.nb_inscrits + " inscrits)";
      }
      return course.nom + notice;
    },
    async get() {

      if (!this.inscription.list_courses.list) {
        this.inscription.list_courses.id_module = this.inscription.id_module;
        await this.inscription.list_courses.fetch();
      }
    },
    updateSelectionCourse(index) {
      this.inscription.list_courses.list.forEach((course) => {
        course.selected = false;
      });
      this.inscription.list_courses.list[index].selected = !this.inscription.list_courses.list[index].selected;
      this.inscription.id_course = this.inscription.list_courses.list[index].id;
      this.inscription.inscription_sportive = this.inscription.list_courses.list[index].metadatas.est_chronometre == "1";

      if (this.inscription.list_courses.list[index].vagues.list.length > 0) {
        this.inscription.id_vague_course = this.inscription.list_courses.list[index].vagues.list[0].id;
      } else {
        this.inscription.id_vague_course = 0;
      }
      this.$emit("updateSelectionCourse");
    },
    updateSelectionVague(index) {
      this.inscription.id_vague_course = this.inscription.list_courses.list[index].vague_selected;
    },
  },

  created() {
    this.inscription = this.item;
    this.get();
  },
};
</script>

<style lang="scss" scoped></style>